import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { useAuth } from '../lib/AuthContext';

/**
 * FR-3: angemeldet (z.B. mit dem MyHours-Konto), aber ohne Eintrag in der MyBudget-
 * Benutzertabelle. Kein Menü, keine Daten -- nur der Hinweis, an wen man sich wendet.
 */
export default function NoAccess() {
  const { claims } = useAuth();
  return (
    <Alert severity="info" sx={{ maxWidth: 640 }}>
      <AlertTitle>Kein Zugriff</AlertTitle>
      Sie sind als {claims?.email ?? 'unbekannt'} angemeldet, haben in MyBudget aber noch keine
      Rolle. Bitte wenden Sie sich an den Admin. Sobald er Sie freigeschaltet hat, melden Sie sich
      einmal ab und wieder an.
    </Alert>
  );
}
